const pinColor: any = {
    RN: "#01665E",
    CNA: "#FFCE3F",
    OT: "#005FDC",
    COTA: "#8AD4F1",
    OTA: "#8AD4F1",
    DO: "#003370",
    STA: "#AFABCB",
    ST: "#4F3184",
    PTA: "#FFCA7D",
    PT: "#E08214",
    PA: "#570068",
    Other: "#000000",
    NP: "#A6611A",
    MSW: "#ED2466",
    MD: "#FF7B00",
    None: "#000000",
    LVN: "#94CCC1",
    LPN: "#94CCC1",
    LMSW: "#B147BC",
    HomeCareAide: "#D95C5C",
    HHA: "#7F47DE",
    EMTP: "#94CA6A",
    EMT: "#3EA123",
    Unassigned: "#000000"
};

export function getSVGIcon(credentials: string, newFillColor?: string) {
    let path = "";
    let fillColor = newFillColor ?? pinColor[credentials];

    switch (credentials) {
        case "EMT":
            path = `<g id="Map-View-with-Tooltip-and-tabs" transform="translate(-277.000000, -371.000000)">
                        <g id="Group" transform="translate(278.000000, 372.000000)">
                            <path d="M13.4584375,39.1929688 C2.10703125,22.7367969 0,21.0478906 0,15 C0,6.71570313 6.71570313,2.84217094e-14 15,2.84217094e-14 C23.2842969,2.84217094e-14 30,6.71570313 30,15 C30,21.0478906 27.8929687,22.7367969 16.5415625,39.1929688 C15.7966406,40.2690625 14.2032812,40.2689844 13.4584375,39.1929688 Z" id="Mask" stroke="${fillColor}" fill="${fillColor}"></path>
                            <text id="EMT" font-family="Open Sans, sans-serif" font-size="12" font-weight="500" fill="#ffffff">
                                <tspan x="3.27441406" y="19">EMT</tspan>
                            </text>
                        </g>
                    </g>`;
            break;

        case "EMTP":
            path = `<g id="Map-View-with-Tooltip-and-tabs" transform="translate(-277.000000, -371.000000)">
                        <g id="Group" transform="translate(278.000000, 372.000000)">
                            <path d="M13.4584375,39.1929688 C2.10703125,22.7367969 0,21.0478906 0,15 C0,6.71570313 6.71570313,2.84217094e-14 15,2.84217094e-14 C23.2842969,2.84217094e-14 30,6.71570313 30,15 C30,21.0478906 27.8929687,22.7367969 16.5415625,39.1929688 C15.7966406,40.2690625 14.2032812,40.2689844 13.4584375,39.1929688 Z" id="Mask" stroke="${fillColor}" fill="${fillColor}"></path>
                            <text id="EMTP" font-family="Open Sans, sans-serif" font-size="12" font-weight="500" fill="#ffffff">
                                <tspan x="3.27441406" y="19">EMTP</tspan>
                            </text>
                        </g>
                    </g>`;
            break;
        case "HHA":
            path = `<g id="Map-View-with-Tooltip-and-tabs" transform="translate(-277.000000, -371.000000)">
                        <g id="Group" transform="translate(278.000000, 372.000000)">
                            <path d="M13.4584375,39.1929688 C2.10703125,22.7367969 0,21.0478906 0,15 C0,6.71570313 6.71570313,2.84217094e-14 15,2.84217094e-14 C23.2842969,2.84217094e-14 30,6.71570313 30,15 C30,21.0478906 27.8929687,22.7367969 16.5415625,39.1929688 C15.7966406,40.2690625 14.2032812,40.2689844 13.4584375,39.1929688 Z" id="Mask" stroke="${fillColor}" fill="${fillColor}"></path>
                            <text id="HHA" font-family="Open Sans, sans-serif" font-size="12" font-weight="500" fill="#FFFFFF">
                                <tspan x="3.27441406" y="19">HHA</tspan>
                            </text>
                        </g>
                    </g>`;
            break;

        case "HomeCareAide":
            path = `<g id="Map-View-with-Tooltip-and-tabs" transform="translate(-277.000000, -371.000000)">
                        <g id="Group" transform="translate(278.000000, 372.000000)">
                            <path d="M13.4584375,39.1929688 C2.10703125,22.7367969 0,21.0478906 0,15 C0,6.71570313 6.71570313,2.84217094e-14 15,2.84217094e-14 C23.2842969,2.84217094e-14 30,6.71570313 30,15 C30,21.0478906 27.8929687,22.7367969 16.5415625,39.1929688 C15.7966406,40.2690625 14.2032812,40.2689844 13.4584375,39.1929688 Z" id="Mask" stroke="${fillColor}" fill="${fillColor}"></path>
                            <text id="HAC" font-family="Open Sans, sans-serif" font-size="12" font-weight="500" fill="#FFFFFF">
                                <tspan x="3.27441406" y="19">HCA</tspan>
                            </text>
                        </g>
                    </g>`;
            break;

        case "LMSW":
            path = `<g id="Map-View-with-Tooltip-and-tabs" transform="translate(-277.000000, -371.000000)">
                        <g id="Group" transform="translate(278.000000, 372.000000)">
                            <path d="M13.4584375,39.1929688 C2.10703125,22.7367969 0,21.0478906 0,15 C0,6.71570313 6.71570313,2.84217094e-14 15,2.84217094e-14 C23.2842969,2.84217094e-14 30,6.71570313 30,15 C30,21.0478906 27.8929687,22.7367969 16.5415625,39.1929688 C15.7966406,40.2690625 14.2032812,40.2689844 13.4584375,39.1929688 Z" id="Mask" stroke="${fillColor}" fill="${fillColor}"></path>
                            <text id="LMSW" font-family="Open Sans, sans-serif" font-size="12" font-weight="500" fill="#ffffff">
                                <tspan x="3.27441406" y="19">LMSW</tspan>
                            </text>
                        </g>
                    </g>`;
            break;

        case "LPN":
            path = `<g id="Map-View-with-Tooltip-and-tabs" transform="translate(-108.000000, -371.000000)">
                        <g id="Group" transform="translate(109.000000, 372.000000)">
                            <path d="M13.4584375,39.1929688 C2.10703125,22.7367969 0,21.0478906 0,15 C0,6.71570313 6.71570313,2.84217094e-14 15,2.84217094e-14 C23.2842969,2.84217094e-14 30,6.71570313 30,15 C30,21.0478906 27.8929687,22.7367969 16.5415625,39.1929688 C15.7966406,40.2690625 14.2032812,40.2689844 13.4584375,39.1929688 Z" id="Mask" stroke="${fillColor}" fill="${fillColor}"></path>
                            <text id="LPN" font-family="Open Sans, sans-serif" font-size="12" font-weight="300" fill="#ffffff">
                                <tspan x="3.13183594" y="19">LPN</tspan>
                            </text>
                        </g>
                    </g>`;
            break;

        case "LVN":
            path = `<g id="Map-View-with-Tooltip-and-tabs" transform="translate(-108.000000, -371.000000)">
                        <g id="Group" transform="translate(109.000000, 372.000000)">
                            <path d="M13.4584375,39.1929688 C2.10703125,22.7367969 0,21.0478906 0,15 C0,6.71570313 6.71570313,2.84217094e-14 15,2.84217094e-14 C23.2842969,2.84217094e-14 30,6.71570313 30,15 C30,21.0478906 27.8929687,22.7367969 16.5415625,39.1929688 C15.7966406,40.2690625 14.2032812,40.2689844 13.4584375,39.1929688 Z" id="Mask" stroke="${fillColor}" "${fillColor}"></path>
                            <text id="LVN" font-family="Open Sans, sans-serif" font-size="12" font-weight="300" fill="#ffffff">
                                <tspan x="3.13183594" y="19">LVN</tspan>
                            </text>
                        </g>
                    </g>`;
            break;

        case "MD":
            path = `<g id="Map-View-with-Tooltip-and-tabs" transform="translate(-66.000000, -371.000000)">
                        <g id="Group" transform="translate(67.000000, 372.000000)">
                            <path d="M13.4584375,39.1929688 C2.10703125,22.7367969 0,21.0478906 0,15 C0,6.71570313 6.71570313,2.84217094e-14 15,2.84217094e-14 C23.2842969,2.84217094e-14 30,6.71570313 30,15 C30,21.0478906 27.8929687,22.7367969 16.5415625,39.1929688 C15.7966406,40.2690625 14.2032812,40.2689844 13.4584375,39.1929688 Z" id="Mask" stroke="${fillColor}" fill="${fillColor}"></path>
                            <text id="MD" font-family="Open Sans, sans-serif" font-size="12" font-weight="500" fill="#ffffff">
                                <tspan x="6.46582031" y="19">MD</tspan>
                            </text>
                        </g>
                    </g>`;
            break;

        case "MSW":
            path = `<g id="Map-View-with-Tooltip-and-tabs" transform="translate(-277.000000, -371.000000)">
                        <g id="Group" transform="translate(278.000000, 372.000000)">
                            <path d="M13.4584375,39.1929688 C2.10703125,22.7367969 0,21.0478906 0,15 C0,6.71570313 6.71570313,2.84217094e-14 15,2.84217094e-14 C23.2842969,2.84217094e-14 30,6.71570313 30,15 C30,21.0478906 27.8929687,22.7367969 16.5415625,39.1929688 C15.7966406,40.2690625 14.2032812,40.2689844 13.4584375,39.1929688 Z" id="Mask" stroke="${fillColor}" fill="${fillColor}"></path>
                            <text id="MSW" font-family="Open Sans, sans-serif" font-size="12" font-weight="500" fill="#ffffff">
                                <tspan x="3.27441406" y="19">MSW</tspan>
                            </text>
                        </g>
                    </g>`;
            break;

        case "None":
            path = `<g id="Map-View-with-Tooltip-and-tabs" transform="translate(-277.000000, -371.000000)">
                        <g id="Group" transform="translate(278.000000, 372.000000)">
                            <path d="M13.4584375,39.1929688 C2.10703125,22.7367969 0,21.0478906 0,15 C0,6.71570313 6.71570313,2.84217094e-14 15,2.84217094e-14 C23.2842969,2.84217094e-14 30,6.71570313 30,15 C30,21.0478906 27.8929687,22.7367969 16.5415625,39.1929688 C15.7966406,40.2690625 14.2032812,40.2689844 13.4584375,39.1929688 Z" id="Mask" fill="${
                                newFillColor ?? "white"
                            }" stroke="${newFillColor ?? "white"}"></path>
                            <text id="None" font-family="Open Sans, sans-serif" font-size="10" font-weight="500" fill="${
                                newFillColor ? "white" : "black"
                            }">
                                <tspan x="3.27441406" y="19">None</tspan>
                            </text>
                        </g>
                    </g>`;
            break;

        case "NP":
            path = `<g id="Map-View-with-Tooltip-and-tabs" transform="translate(-232.000000, -371.000000)">
                        <g id="Group" transform="translate(233.000000, 372.000000)">
                            <path d="M13.4584375,39.1929688 C2.10703125,22.7367969 0,21.0478906 0,15 C0,6.71570313 6.71570313,2.84217094e-14 15,2.84217094e-14 C23.2842969,2.84217094e-14 30,6.71570313 30,15 C30,21.0478906 27.8929687,22.7367969 16.5415625,39.1929688 C15.7966406,40.2690625 14.2032812,40.2689844 13.4584375,39.1929688 Z" id="Mask" stroke="${fillColor}" fill="${fillColor}"></path>
                            <text id="NP" font-family="Open Sans, sans-serif" font-size="12" font-weight="500" fill="#FFFFFF">
                                <tspan x="7.07128906" y="19">NP</tspan>
                            </text>
                        </g>
                    </g>`;
            break;

        case "OTA":
            path = `<g id="Map-View-with-Tooltip-and-tabs" transform="translate(-277.000000, -371.000000)">
                        <g id="Group" transform="translate(278.000000, 372.000000)">
                            <path d="M13.4584375,39.1929688 C2.10703125,22.7367969 0,21.0478906 0,15 C0,6.71570313 6.71570313,2.84217094e-14 15,2.84217094e-14 C23.2842969,2.84217094e-14 30,6.71570313 30,15 C30,21.0478906 27.8929687,22.7367969 16.5415625,39.1929688 C15.7966406,40.2690625 14.2032812,40.2689844 13.4584375,39.1929688 Z" id="Mask" stroke="${fillColor}" fill="${fillColor}"></path>
                            <text id="OTA" font-family="Open Sans, sans-serif" font-size="12" font-weight="500" fill="#ffffff">
                                <tspan x="3.27441406" y="19">OTA</tspan>
                            </text>
                        </g>
                    </g>`;
            break;

        case "Other":
            path = `<g id="Map-View-with-Tooltip-and-tabs" transform="translate(-277.000000, -371.000000)">
                        <g id="Group" transform="translate(278.000000, 372.000000)">
                            <path d="M13.4584375,39.1929688 C2.10703125,22.7367969 0,21.0478906 0,15 C0,6.71570313 6.71570313,2.84217094e-14 15,2.84217094e-14 C23.2842969,2.84217094e-14 30,6.71570313 30,15 C30,21.0478906 27.8929687,22.7367969 16.5415625,39.1929688 C15.7966406,40.2690625 14.2032812,40.2689844 13.4584375,39.1929688 Z" id="Mask" fill="${
                                newFillColor ?? "white"
                            }" stroke="${newFillColor ?? "white"}"></path>
                            <text id="Other" font-family="Open Sans, sans-serif" font-size="10" font-weight="500" fill="${
                                newFillColor ? "white" : "black"
                            }">
                                <tspan x="3.27441406" y="19">Other</tspan>
                            </text>
                        </g>
                    </g>`;
            break;

        case "PA":
            path = `<g id="Map-View-with-Tooltip-and-tabs" transform="translate(-277.000000, -371.000000)">
                        <g id="Group" transform="translate(278.000000, 372.000000)">
                            <path d="M13.4584375,39.1929688 C2.10703125,22.7367969 0,21.0478906 0,15 C0,6.71570313 6.71570313,2.84217094e-14 15,2.84217094e-14 C23.2842969,2.84217094e-14 30,6.71570313 30,15 C30,21.0478906 27.8929687,22.7367969 16.5415625,39.1929688 C15.7966406,40.2690625 14.2032812,40.2689844 13.4584375,39.1929688 Z" id="Mask" stroke="${fillColor}" fill="${fillColor}"></path>
                            <text id="PA" font-family="Open Sans, sans-serif" font-size="12" font-weight="500" fill="#ffffff">
                                <tspan x="3.27441406" y="19">PA</tspan>
                            </text>
                        </g>
                    </g`;
            break;

        case "PT":
            path = `<g id="Map-View-with-Tooltip-and-tabs" transform="translate(-151.000000, -371.000000)">
                        <g id="Group" transform="translate(152.000000, 372.000000)">
                            <path d="M13.4584375,39.1929688 C2.10703125,22.7367969 0,21.0478906 0,15 C0,6.71570313 6.71570313,2.84217094e-14 15,2.84217094e-14 C23.2842969,2.84217094e-14 30,6.71570313 30,15 C30,21.0478906 27.8929687,22.7367969 16.5415625,39.1929688 C15.7966406,40.2690625 14.2032812,40.2689844 13.4584375,39.1929688 Z" id="Mask" stroke="${fillColor}" fill="${fillColor}"></path>
                            <text id="PT" font-family="Open Sans, sans-serif" font-size="12" font-weight="500" fill="#FFFFFF">
                                <tspan x="7.13964844" y="19">PT</tspan>
                            </text>
                        </g>
                    </g>`;
            break;

        case "PTA":
            path = `<g id="Map-View-with-Tooltip-and-tabs" transform="translate(-191.000000, -371.000000)">
                        <g id="Group" transform="translate(192.000000, 372.000000)">
                            <path d="M13.4584375,39.1929688 C2.10703125,22.7367969 0,21.0478906 0,15 C0,6.71570313 6.71570313,2.84217094e-14 15,2.84217094e-14 C23.2842969,2.84217094e-14 30,6.71570313 30,15 C30,21.0478906 27.8929687,22.7367969 16.5415625,39.1929688 C15.7966406,40.2690625 14.2032812,40.2689844 13.4584375,39.1929688 Z" id="Mask" stroke=${fillColor} fill=${fillColor}></path>
                            <text id="PTA" font-family="Open Sans, sans-serif" font-size="12" font-weight="500" fill="#ffffff">
                                <tspan x="3.34277344" y="19">PTA</tspan>
                            </text>
                        </g>
                    </g>`;
            break;

        case "ST":
            path = `<g id="Map-View-with-Tooltip-and-tabs" transform="translate(-316.000000, -371.000000)">
                        <g id="Group" transform="translate(317.000000, 372.000000)">
                            <path d="M13.4584375,39.1929688 C2.10703125,22.7367969 0,21.0478906 0,15 C0,6.71570313 6.71570313,2.84217094e-14 15,2.84217094e-14 C23.2842969,2.84217094e-14 30,6.71570313 30,15 C30,21.0478906 27.8929687,22.7367969 16.5415625,39.1929688 C15.7966406,40.2690625 14.2032812,40.2689844 13.4584375,39.1929688 Z" id="Mask" stroke="${fillColor}" fill="${fillColor}"></path>
                            <text id="ST" font-family="Open Sans, sans-serif" font-size="12" font-weight="500" fill="#FFFFFF">
                                <tspan x="7.13085938" y="19">ST</tspan>
                            </text>
                        </g>
                    </g>`;
            break;

        case "STA":
            path = `<g id="Map-View-with-Tooltip-and-tabs" transform="translate(-358.000000, -371.000000)">
                        <g id="Group" transform="translate(359.000000, 372.000000)">
                            <path d="M13.4584375,39.1929688 C2.10703125,22.7367969 0,21.0478906 0,15 C0,6.71570313 6.71570313,2.84217094e-14 15,2.84217094e-14 C23.2842969,2.84217094e-14 30,6.71570313 30,15 C30,21.0478906 27.8929687,22.7367969 16.5415625,39.1929688 C15.7966406,40.2690625 14.2032812,40.2689844 13.4584375,39.1929688 Z" id="Mask" stroke="${fillColor}" fill="${fillColor}"></path>
                            <text id="STA" font-family="Open Sans, sans-serif" font-size="12" font-weight="500" fill="#ffffff">
                                <tspan x="3.33398438" y="19">STA</tspan>
                            </text>
                        </g>
                    </g>`;
            break;

        case "Unassigned":
            path = `<g id="Map-View-with-Tooltip-and-tabs" transform="translate(-277.000000, -371.000000)">
                        <g id="Group" transform="translate(278.000000, 372.000000)">
                            <path d="M13.4584375,39.1929688 C2.10703125,22.7367969 0,21.0478906 0,15 C0,6.71570313 6.71570313,2.84217094e-14 15,2.84217094e-14 C23.2842969,2.84217094e-14 30,6.71570313 30,15 C30,21.0478906 27.8929687,22.7367969 16.5415625,39.1929688 C15.7966406,40.2690625 14.2032812,40.2689844 13.4584375,39.1929688 Z" id="Mask" fill="${
                                newFillColor ?? "white"
                            }" stroke="${newFillColor ?? "white"}"></path>
                            <text id="Unassigned" font-family="Open Sans, sans-serif" font-size="10" font-weight="500" fill="${
                                newFillColor ? "white" : "black"
                            }">
                                <tspan x="3.27441406" y="19"></tspan>
                            </text>
                        </g>
                    </g>`;
            break;

        case "DO":
            path = `<g id="Map-View-with-Tooltip-and-tabs" transform="translate(-277.000000, -371.000000)">
                        <g id="Group" transform="translate(278.000000, 372.000000)">
                            <path d="M13.4584375,39.1929688 C2.10703125,22.7367969 0,21.0478906 0,15 C0,6.71570313 6.71570313,2.84217094e-14 15,2.84217094e-14 C23.2842969,2.84217094e-14 30,6.71570313 30,15 C30,21.0478906 27.8929687,22.7367969 16.5415625,39.1929688 C15.7966406,40.2690625 14.2032812,40.2689844 13.4584375,39.1929688 Z" id="Mask" stroke="${fillColor}" fill="${fillColor}"></path>
                            <text id="DO" font-family="Open Sans, sans-serif" font-size="12" font-weight="500" fill="#FFFFFF">
                                <tspan x="6.46582031" y="19">DO</tspan>
                            </text>
                        </g>
                    </g>`;
            break;

        case "COTA":
            path = `<g id="Map-View-with-Tooltip-and-tabs" transform="translate(-277.000000, -371.000000)">
                        <g id="Group" transform="translate(278.000000, 372.000000)">
                            <path d="M13.4584375,39.1929688 C2.10703125,22.7367969 0,21.0478906 0,15 C0,6.71570313 6.71570313,2.84217094e-14 15,2.84217094e-14 C23.2842969,2.84217094e-14 30,6.71570313 30,15 C30,21.0478906 27.8929687,22.7367969 16.5415625,39.1929688 C15.7966406,40.2690625 14.2032812,40.2689844 13.4584375,39.1929688 Z" id="Mask" stroke="${fillColor}" fill="${fillColor}"></path>
                            <text id="COTA" font-family="Open Sans, sans-serif" font-size="12" font-weight="500" fill="#ffffff">
                                <tspan x="3.27441406" y="19">COTA</tspan>
                            </text>
                        </g>
                    </g>`;
            break;

        case "CNA":
            path = `<g id="Map-View-with-Tooltip-and-tabs" transform="translate(-277.000000, -371.000000)">
                        <g id="Group" transform="translate(278.000000, 372.000000)">
                            <path d="M13.4584375,39.1929688 C2.10703125,22.7367969 0,21.0478906 0,15 C0,6.71570313 6.71570313,2.84217094e-14 15,2.84217094e-14 C23.2842969,2.84217094e-14 30,6.71570313 30,15 C30,21.0478906 27.8929687,22.7367969 16.5415625,39.1929688 C15.7966406,40.2690625 14.2032812,40.2689844 13.4584375,39.1929688 Z" id="Mask" stroke="${fillColor}" fill="${fillColor}"></path>
                            <text id="CNA" font-family="Open Sans, sans-serif" font-size="12" font-weight="500" fill="#ffffff">
                                <tspan x="3.27441406" y="19">CNA</tspan>
                            </text>
                        </g>
                    </g>`;
            break;

        case "RN":
            path = `<g id="Map-View-with-Tooltip-and-tabs" transform="translate(-66.000000, -371.000000)">
                        <g id="Group" transform="translate(67.000000, 372.000000)">
                            <path d="M13.4584375,39.1929688 C2.10703125,22.7367969 0,21.0478906 0,15 C0,6.71570313 6.71570313,2.84217094e-14 15,2.84217094e-14 C23.2842969,2.84217094e-14 30,6.71570313 30,15 C30,21.0478906 27.8929687,22.7367969 16.5415625,39.1929688 C15.7966406,40.2690625 14.2032812,40.2689844 13.4584375,39.1929688 Z" id="Mask" stroke="${fillColor}" fill="${fillColor}"></path>
                            <text id="RN" font-family="Open Sans, sans-serif" font-size="12" font-weight="500" fill="#FFFFFF">
                                <tspan x="6.46582031" y="19">RN</tspan>
                            </text>
                        </g>
                    </g>`;
            break;

        case "OT":
            path = `<g id="Map-View-with-Tooltip-and-tabs" transform="translate(-232.000000, -371.000000)">
                        <g id="Group" transform="translate(233.000000, 372.000000)">
                            <path d="M13.4584375,39.1929688 C2.10703125,22.7367969 0,21.0478906 0,15 C0,6.71570313 6.71570313,2.84217094e-14 15,2.84217094e-14 C23.2842969,2.84217094e-14 30,6.71570313 30,15 C30,21.0478906 27.8929687,22.7367969 16.5415625,39.1929688 C15.7966406,40.2690625 14.2032812,40.2689844 13.4584375,39.1929688 Z" id="Mask" stroke="${fillColor}" fill="${fillColor}"></path>
                            <text id="OT" font-family="Open Sans, sans-serif" font-size="12" font-weight="500" fill="#FFFFFF">
                                <tspan x="7.07128906" y="19">OT</tspan>
                            </text>
                        </g>
                    </g>`;
            break;

        default:
            path = `<g id="Map-View-with-Tooltip-and-tabs" transform="translate(-277.000000, -371.000000)">
                        <g id="Group" transform="translate(278.000000, 372.000000)">
                            <path d="M13.4584375,39.1929688 C2.10703125,22.7367969 0,21.0478906 0,15 C0,6.71570313 6.71570313,2.84217094e-14 15,2.84217094e-14 C23.2842969,2.84217094e-14 30,6.71570313 30,15 C30,21.0478906 27.8929687,22.7367969 16.5415625,39.1929688 C15.7966406,40.2690625 14.2032812,40.2689844 13.4584375,39.1929688 Z" id="Mask" fill="${
                                newFillColor ?? "white"
                            }" stroke="${newFillColor ?? "white"}"></path>
                            <text id="Unassigned" font-family="Open Sans, sans-serif" font-size="10" font-weight="500" fill="${
                                newFillColor ? "white" : "black"
                            }">
                                <tspan x="3.27441406" y="19"></tspan>
                            </text>
                        </g>
                    </g>`;
            break;
    }
    let svg = `<?xml version="1.0" encoding="UTF-8"?>
                <svg width="32px" height="42px" viewBox="0 0 32 42" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                    <title>${credentials}</title>
                    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                        ${path}
                    </g>
                </svg>`;
    return svg;
}
